import { useDispatch, useSelector } from 'react-redux';
import SyringeSolidIcon from '../../../../../../icons/solid/syringe-solid';
import PrescribeAutoSuggestV2 from '../../PrescribeAutoSuggestV2';
import InjectionTable from './injectionTable/InjectionTable';
import ModuleActions from './moduleActions/ModuleActions';
import { upsertInjection } from '../../../../../../store/actions/prescriptionPad';
import { InjectionsEntity } from '../../../../../../store/types/prescription';
import { getInjectionElements } from '../../../../../../store/selectors/prescriptionPad';

const InjectionModule = (): JSX.Element => {
    const dispatch = useDispatch();
    const injectionElements = useSelector(getInjectionElements);
    return (
        <div className="rounded-8 pt-8 px-16 pb-16 bg-white row focusable">
            <div className="flex items-center justify-between space-x-8">
                <div className="flex flex-row items-center">
                    <div className="space-x-10 flex items-center">
                        <div className="bg-darwin-accent-medicines-pink-800 rounded-4 py-7 px-5">
                            <SyringeSolidIcon className="w-16 h-12 text-white" />
                        </div>
                        <div className="font-700 text-16 text-neutral-1000">Injections</div>
                    </div>
                </div>
                <div className="flex flex-row space-x-16">
                    <ModuleActions />
                </div>
            </div>
            <div className="mb-8" />
            {injectionElements && injectionElements.length > 0 ? <InjectionTable /> : null}
            <div className="mb-8" />
            <div className="w-full">
                <PrescribeAutoSuggestV2
                    kind={'Injections'}
                    onSelect={(drug) => {
                        dispatch(upsertInjection(drug as InjectionsEntity));
                    }}
                    hideCustomEntity={true}
                />
            </div>
        </div>
    );
};

export default InjectionModule;
